import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable, defer, from } from 'rxjs';
import { LocalitiAuthService } from './localiti-auth.service';
@Injectable({
  providedIn: 'root'
})
export class ClientGuardService implements CanActivate {

  constructor(public auth: LocalitiAuthService, private router: Router) { 


  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    console.log("canactivate");
    return defer(() => from(new Promise<boolean>(async res => {
      const isLoggedIn = await this.auth.isLoggedIn;
      const isClient = await this.auth.isClient;
      if (isLoggedIn && isClient) {
        res(true);
      } else {
        if (isLoggedIn) {
          this.router.navigate(['/signup']);
        } else {
          this.router.navigate(['/login']);
        }
        res(false);
      }        
    })));
    // return this.auth.user.pipe(map(val => {
      
    //   if (val) {

    //     console.log("can activate user set");
    //     return true;
    //   } else {
    //     console.log("can activate NO user set");
    //   //  this.router.navigate(['/login']);        
    //     return false;
    //   }}));
      
  }
}
